import React, { Component, createRef } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { setAddEditFormData } from '../../../../redux/action/Tenant/TenantActions';
import GreenTick from '../../../../assets/images/module/general/GreenTick.svg';
import RedCross from '../../../../assets/images/module/general/RedCross.svg';
import Autoload from '../../../../neoverv/Autoload';
import { Skeleton, Stack } from '@mantine/core';
import CustomRichTextEditor from '../../../../components/CustomRichTextEditor';
import { hideNotification, showNotification } from '@mantine/notifications';
import moment from 'moment';

var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];
const { checkProperty, loader } = Autoload.MainHelper;

export class TenantNotes extends Component {
  state = {
    notes: null,
    skeletonLoading: false,
    initialNotesLoaded: false, // 👈 NEW
  };

  constructor(props){
    super(props);
    this.typingTimeout = null; // Timer to handle the debounce
    this.editorRef = createRef();
  }

  componentDidMount() {
    const loader = document.getElementById('hello-housing-loader');
    loader.style.display = 'none';
    this.setState({ skeletonLoading: true });
  
    const { formData } = this.props;
    this.setState({
      notes: checkProperty(formData, 'note'),
      initialNotesLoaded: true // 👈 Mark that initial data has been set
    });
  
    this.ShowLoader();
  }

  onInputChange = (field, value) => {
    this.setState({ [field]: value });
  };

  //save data to redux everytime state changes
  componentDidUpdate(prevProps, prevState) {
    if (this.state !== prevState) {
      const { notes } = this.state;
      let data = {
        ...this.props.formData,
        note: notes,
      };
      //save data to redux
      this.props.setAddEditFormData(data);
    }
  }
  ShowLoader = () => {
    var loader = document.getElementById('hello-housing-loader');
    loader.style.display = 'none';
    var emptyDiv = document.getElementById('empty-tenant-notes-page');
    emptyDiv.style.display = 'none';
    var dataDiv = document.getElementById('tenant-notes-page');
    dataDiv.style.display = 'block';
    this.setState({skeletonLoading: false});
  };

  editTenant = () => {
    hideNotification('saveTenantData');
    console.log('form data', this.props.formData);
    var data = JSON.stringify({
      tenantId: checkProperty(this.props.formData, 'id'),
      rentalUnitId: checkProperty(this.props.formData, 'rentalUnitId'),
      fullName: checkProperty(this.props.formData, 'name'),
      contractType: checkProperty(this.props.formData, 'type'),
      vacant: false,
      phone: checkProperty(this.props.formData, 'phone'),
      email: checkProperty(this.props.formData, 'email'),
      moveInDate:
        checkProperty(this.props.formData, 'in') == ''
          ? ''
          : moment(checkProperty(this.props.formData, 'in'), 'DD.MM.YYYY').format('YYYY-MM-DDTHH:mm:ss'),
      moveOutDate:
        checkProperty(this.props.formData, 'out') == null || checkProperty(this.props.formData, 'out') == ''
          ? null
          : moment(checkProperty(this.props.formData, 'out'), 'DD.MM.YYYY').format('YYYY-MM-DDTHH:mm:ss'),
      notes: checkProperty(this.props.formData, 'note'),
      numberOfOccupants: parseInt(checkProperty(this.props.formData, 'numberOfOccupants')),
      isSecondaryAddressActive: checkProperty(this.props.formData, 'isSecondaryAddressActive'),
      secondaryAddressName: checkProperty(this.props.formData, 'secondaryAddressName'),
      secondaryAddressStreet: checkProperty(this.props.formData, 'secondaryAddressStreet'),
      secondaryAddressZipCode: checkProperty(this.props.formData, 'secondaryAddressZipCode'),
      secondaryAddressCity: checkProperty(this.props.formData, 'secondaryAddressCity')
    });
    console.log('form data', data);
    // debugger
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.property_api_base_url + 'tenants/' + checkProperty(this.props.formData, 'id'),
      'PUT',
      data,
      null,
      false,
      true,
      false,
      this,
      'handleEditTenant',
      null,
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      },
      true
    );

    // this.handleEditTenant()
  };
  handleEditTenant = (response) => {
    console.log('response edit tenant api', response);
    // const unitId = checkProperty(this.props.history.location.state, 'unitId')
    // let record = {
    //   ...this.props.formData,
    // }
    // this.props.editTenant(unitId, record)
    if(response.status === true && response.statuscode === 200){
      showNotification({
        id: 'saveTenantData',
        message: 'Die Änderungen wurden übernommen.',
        icon: <img src={GreenTick} alt='green-tick'/>,
      });
    }else{
      showNotification({
        id: 'saveTenantData',
        message: 'Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.',
        icon: <img src={RedCross} alt='red-cross'/>,
      });
    }
    loader(false);
  };

  validateNotesLength=(value)=>{
    return value.length > 5000 ? false : true;
  }

  handleChange = (value, delta, source, editor) => {
    hideNotification('notesLengthError');
    console.log('handleChange: ', source);
    if(source !== 'api'){
      let parser = new DOMParser();
      const valueCopy = value;
      let doc = parser.parseFromString(valueCopy, 'text/html');
      console.log('handleChange: ', 'inside');
      let modifiedHtmlString = doc.body.innerHTML;
      
      if(this.validateNotesLength(modifiedHtmlString)){
        this.onInputChange('notes', modifiedHtmlString);
        // Clear the previous timeout if user is still typing
        if (this.typingTimeout) {
          clearTimeout(this.typingTimeout);
        }
        // // Set a new timeout to trigger the API call after 3 seconds of inactivity
        this.typingTimeout = setTimeout(this.handleUserStoppedTyping, 3000);
      }else{
        showNotification({
          id: 'notesLengthError',
          message: 'Inhalt nicht gespeichert. Sie haben die maximale Länge des Notizfeldes überschritten.',
          icon: <img src={RedCross} alt='red-cross'/>,
        });
      }
    }
  }

  handleUserStoppedTyping = () => {
    console.log('User stopped typing. Making API call...');
    // Replace this with your API call
    this.editTenant();
    //this.props.updateHtml(this.props.body, true);
    this.typingTimeout = null;
  };

  renderRTE = () => {
    const { notes, initialNotesLoaded } = this.state;
    console.log('notes: ', notes);
  
    return (
      <Stack style={{marginTop: '20px'}}>
        <CustomRichTextEditor
          key={initialNotesLoaded ? 'loaded' : 'loading'} // optional: prevent stale re-render on load
          value={initialNotesLoaded ? notes : ''} // only apply after initial load
          ref={this.editorRef}
          onChange={this.handleChange}
          className={'rich-text-editor-for-tenant-notes'}
        />
      </Stack>
    );
  };
  

  render() {
    return (
      <>
        <div id="empty-tenant-notes-page"></div>
        <div className="tenant-notes-section" id="tenant-notes-page" style={{ display: 'block' }}>
          <Form noValidate>
            <Row>
              <Col xs={6}>
                <Form.Group>
                  <Skeleton visible={this.state.skeletonLoading}>
                    {this.renderRTE()}
                  </Skeleton>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentRecord: state.tenantDataReducer.currentTenant,
    formData: state.tenantDataReducer.addEditFormData,
  };
};
const actions = {
  setAddEditFormData,
};

export default connect(mapStateToProps, actions)(TenantNotes);
